<template>
  <Teleport to="body">
    <transition name="bk-slide-in" :duration="200">
      <FormOverlay
        v-if="isVisible"
        :id="id"
        :title="title"
        :icon="icon"
        @close="onClose"
      >
        <slot />
        <template #footer>
          <button class="bk-button bk-is-primary" @click="onSubmit">
            {{ $t("droppableEditFormSave", "Save") }}
          </button>
        </template>
      </FormOverlay>
    </transition>
  </Teleport>
</template>

<script setup>
import { FormOverlay } from "#blokkli/components";
import onBlokkliEvent from "#blokkli/helpers/composables/onBlokkliEvent";
import { ref, useBlokkli } from "#imports";
const props = defineProps({
  id: { type: String, required: true },
  title: { type: String, required: true },
  icon: { type: null, required: true },
  entityType: { type: String, required: true }
});
const emit = defineEmits(["save"]);
const { $t, types, state } = useBlokkli();
const droppable = ref(null);
const isVisible = ref(false);
const onClose = () => {
  isVisible.value = false;
};
const onSubmit = () => {
  if (droppable.value) {
    emit("save", droppable.value.field);
  }
  isVisible.value = false;
  droppable.value = null;
};
onBlokkliEvent("droppable:focus", (field) => {
  if (state.editMode.value !== "editing") {
    return;
  }
  const config = types.getDroppableFieldConfig(field.fieldName, field.host);
  if (config.allowedEntityType === props.entityType) {
    isVisible.value = true;
    droppable.value = { field, config };
  }
});
</script>
